import React, { useState, useEffect } from 'react';
import BoxBtn from '../../btns/box-btn/BoxBtn.js';
import {
  PaginationContainer,
  PaginationNavigation,
  PaginationBtnContainer,
  BtnContainer,
  PageInputContainer,
  PageInput,
  LoadingIndicator
} from './SystemPaginationControls.styles.js';

export default function SystemPaginationControls({
  currentPage,
  totalPages,
  isLoading = false,
  onPageChange,
  showPageInput = true,
  showLoadingIndicator = true
}) {
  const [inputValue, setInputValue] = useState(currentPage.toString());

  useEffect(() => {
    setInputValue(currentPage.toString());
  }, [currentPage]);

  const goToPage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages && pageNumber !== currentPage && !isLoading) {
      onPageChange(pageNumber);
    }
  };

  const handlePageInputChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^\d+$/.test(value)) {
      setInputValue(value);
    }
  };

  const validateAndNavigate = () => {
    const pageNumber = parseInt(inputValue);
    if (isNaN(pageNumber) || inputValue === '') {
      setInputValue(currentPage.toString());
      return;
    }
    const clampedPage = Math.max(1, Math.min(pageNumber, totalPages));
    setInputValue(clampedPage.toString());
    if (clampedPage !== currentPage) {
      goToPage(clampedPage);
    }
  };

  const handlePageInputBlur = () => {
    validateAndNavigate();
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      validateAndNavigate();
    }
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <PaginationContainer>
      <PaginationNavigation>
        <PaginationBtnContainer>
          <BtnContainer>
            <BoxBtn
              onClick={() => goToPage(1)}
              disabled={currentPage === 1 || isLoading}
              title="<<"
            />
          </BtnContainer>
          <BtnContainer>
            <BoxBtn
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1 || isLoading}
              title="<"
            />
          </BtnContainer>
        </PaginationBtnContainer>

        {showPageInput && (
          <PageInputContainer>
            <span>Page:</span>
            <PageInput
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={inputValue}
              onChange={handlePageInputChange}
              onBlur={handlePageInputBlur}
              onKeyDown={handlePageInputKeyDown}
              disabled={isLoading}
              aria-label={`Page number, currently page ${currentPage} of ${totalPages}`}
            />
            <span>of {totalPages}</span>
          </PageInputContainer>
        )}

        <PaginationBtnContainer>
          <BoxBtn
            onClick={() => goToPage(currentPage + 1)}
            disabled={currentPage === totalPages || isLoading}
            title=">"
          />
          <BoxBtn
            onClick={() => goToPage(totalPages)}
            disabled={currentPage === totalPages || isLoading}
            title=">>"
          />
        </PaginationBtnContainer>
      </PaginationNavigation>

      {showLoadingIndicator && isLoading && (
        <LoadingIndicator>Loading page {currentPage}...</LoadingIndicator>
      )}
    </PaginationContainer>
  );
}
